<template>
    <vs-popup :active.sync="active">
        <vs-row>
            <vs-col>
                <template v-if="data.issue_type == 'major_maintenance' && data.module_key">
                    <div class="text-center">
                        <p class="mb-1"><b>Issue ID:</b> #{{ data.secondary_id }}</p>
                        <p class="mb-1"><b>Major Maintenance Sub Type:</b> {{ dpr_module_key[data.module_key] }}</p>
                        <p class="mb-1"><b>Created On:</b> <FormatText :text="data.created_on" format="datetime" /></p>
                        <p class="mb-1"><b>Organisation:</b> {{ data.organisation.name }}</p>
                        <div class="mt-base">
                            <router-link :to="{name: 'dpr-entries', params: {issue_type: data.issue_type, module_key: data.module_key}, query: {search: data.id}}" :target="'_blank'">
                                <vs-button color="primary" size="small" class="mx-2">View</vs-button>
                            </router-link>
                            <vs-button @click="active=false" size="small" color="primary" class="mx-2">Cancel</vs-button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="text-center">
                        <p class="mb-1"><b>Issue ID:</b> #{{ data.secondary_id }}</p>
                        <p class="mb-1"><b>Issue Type:</b> {{ issue_type[data.issue_type] }}</p>
                        <p class="mb-1"><b>Created On:</b> <FormatText :text="data.created_on" format="datetime" /></p>
                        <p class="mb-1"><b>Organisation:</b> {{ data.organisation.name }}</p>
                        <div class="mt-base">
                            <router-link :to="{name: 'issues-list', params: {issue_type: data.issue_type}, query: {search: data.id}}" :target="'_blank'">
                                <vs-button color="primary" size="small" class="mx-2">View</vs-button>
                            </router-link>
                            <vs-button @click="active=false" size="small" color="primary" class="mx-2">Cancel</vs-button>
                        </div>
                    </div>
                </template>
            </vs-col>
        </vs-row>
    </vs-popup>
</template>

<script>
export default {
    props: {
        is_active: {
            type: Boolean,
            required: true,
            default: false
        },
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            active: this.is_active,

            issue_type: {
                routine_maintenance: 'Routine Maintenance',
                electrical_maintenance: 'Electrical Maintenance',
                major_maintenance: 'Major Maintenance',
                highway: 'Corrective Maintenance',
                road_user_accident: 'Road User Accident',
                occupational: 'Occupational',
                hazard: 'Hazard',
                dead_animal_debris_removal: 'Dead Animal Debris Removal',
                vehicle_breakdown: 'Vehicle Breakdown',
                traffic_violation: 'Traffic Violation',
                unauthorised_parking: 'Unauthorised Parking',
                unauthorised_access: 'Unauthorised Access',
                unauthorised_media_cut: 'Unauthorised Median Cut',
                material_damage: 'Material Damage',
                other: 'Other',
                enroachment_row: 'Enroachment Row',
            },

            dpr_module_key: {
                mm_bituminous_concrete_overlay: 'Bituminous Concrete Overlay',
                mm_dense_bituminous_concrete_overlay: 'Dense Bituminous Concrete Overlay',
                mm_milling: 'Milling',
                mm_thermoplastic_road_marking: 'Thermoplastic RoadMarking',
                mm_shoulder_raising: 'Shoulder Raising',
                mm_road_sruds_fixing: 'RoadSruds Fixing',
                mm_kerb_topping: 'KerbTopping',
                mm_kerb_painting: 'KerbPainting',
                mm_microsurfacing: 'MicroSurfacing',
                mm_tack_coat: 'Tack Coat',
            },
        }
    },
    watch: {
        active (newV, oldV) {
            if (newV !== oldV) this.$emit('update:is_active', newV)
        },
        is_active (newV, oldV) {
            if (newV !== oldV) this.active = newV
        }
    }
}
</script>